var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"wrapper"},[_c('Header'),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"left-content"},[_c('SideMenu')],1),_vm._v(" "),_c('div',{staticClass:"main-content"},[_c('router-view'),_vm._v(" "),_c('div',{staticClass:"bottom-content"},[_c('Footer')],1)],1)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ae24a48","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 